module.exports = __webpack_public_path__ + "img/Repost-symbol__white.f1465b25.svg";